import { type HttpClient } from '../useHttpClient';
import { type Response } from '../hooks/usePostsChartData';

export const getPostsChartData =
  (httpClient: HttpClient) => async (data: any) => {
    const response = await httpClient.api('/admin/posts/chart', {
      method: 'POST',
      body: JSON.stringify(data),
    });

    return response.json as Response;
  };
